import React from "react";
import { cx } from "utils/join-classnames";
import styles from "./Spinner.module.scss";

type Props = {
    size?: "small" | "medium" | "large";
    className?: string;
};

const Spinner: React.FC<Props> = ({ size, className }) => (
        <div
            className={cx(
                styles.spinner,
                size === "medium" ? styles.spinner__medium : null,
                size === "large" ? styles.spinner__large : null,
                className,
            )}
        />
    );

export default Spinner;
